module.exports = __webpack_public_path__ + "assets/img/logout.3c6061e9.png";